import styled from 'styled-components';
import { themeGet, getTextColor, getBorderColor } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
export const Container = styled(Flex)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Main = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div {
    display: flex;
    align-items: center;
  }
`;
export const Score = styled(Text)`
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  font-size: ${props => themeGet('fontSizes.7')(props)}px;
`;
export const Description = styled(Text)`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  color: ${props => getTextColor('light')(props)};
`;
export const Divider = styled(Box)`
  border-left: 3px solid ${props => getBorderColor('light')(props)};
  height: 90px;
  margin: 0px 24px;
`;